import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { withStyles, WithStyles } from "@mui/styles";
import { DrawerBoxStyleClasses } from "assets/jss/common-styles";
import * as React from 'react';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

type Props = IProps & Omit<DrawerProps, "anchor" | "onBackdropClick" | "onEscapeKeyDown"> & WithStyles<typeof DrawerBoxStyleClasses>;


const WidgetDrawer: React.FC<Props> = (props) => {

    const { classes, children, open, onClose, ...rest } = props;

    return (
        <Drawer
            classes={{ paper: classes.paper }}
            anchor="right"
            open={open}
            onBackdropClick={onClose}
            onClose={onClose}
            {...rest}
        >
            {children}
        </Drawer >
    );
}

WidgetDrawer.defaultProps = {
    open: true
}

export default withStyles(DrawerBoxStyleClasses)(WidgetDrawer)
